import { Component } from '../Component.js';
import { BRAND } from '../../config/brand.js';

const VIEW_LABELS = {
  team:        'Team',
  facilitator: 'Facilitator',
  scorer:      'Scorer',
  board:       'Licence Board',
};

const ROLE_VIEWS = {
  team:        ['team'],
  facilitator: ['facilitator', 'scorer', 'board'],
  scorer:      ['scorer', 'board'],
  board:       ['board'],
  master:      ['facilitator', 'scorer', 'board'],
};

export class Nav extends Component {
  /** @param {(view: string) => void} onSwitch */
  constructor(el, onSwitch) {
    super(el, { role: '', connected: false, activeView: '' });
    this.onSwitch = onSwitch;
  }

  template() {
    const { role, connected, activeView } = this.props;
    const views = ROLE_VIEWS[role] ?? [];

    const tabs = views.map(v => `
      <button
        class="nav__tab${v === activeView ? ' nav__tab--active' : ''}"
        data-view="${v}"
        aria-pressed="${v === activeView}"
        aria-label="Switch to ${VIEW_LABELS[v]} view"
      >${VIEW_LABELS[v]}</button>
    `).join('');

    return `
      <div class="nav__brand" aria-label="Application name">
        <span class="status-dot${connected ? ' status-dot--live' : ''}" aria-hidden="true"></span>
        <span>${BRAND.companyShort}</span>
      </div>
      <nav class="nav__tabs" role="navigation" aria-label="View switcher">
        ${tabs}
      </nav>
    `;
  }

  bindEvents() {
    this.$$('.nav__tab').forEach(btn => {
      const handler = () => {
        const view = btn.dataset.view;
        this.props.activeView = view;
        this.$$('.nav__tab').forEach(b => {
          b.classList.toggle('nav__tab--active', b.dataset.view === view);
          b.setAttribute('aria-pressed', b.dataset.view === view);
        });
        this.onSwitch(view);
      };
      btn.addEventListener('click', handler);
      this.addCleanup(() => btn.removeEventListener('click', handler));
    });
  }

  setConnected(connected) { this.update({ connected }); }
  setActiveView(v)         { this.update({ activeView: v }); }
  setRole(role, view)      { this.update({ role, activeView: view }); }
}
